<template>
  <div class="card" style="position: relative">
    <div style="cursor: pointer;" @click="showVideo()">
      <img class="lazyload" :data-src="video.thumbnail" @error="replaceByDefaultVideoThumbnail">
    </div>
    <div class="community_like_group_light">
      <img class="lazyload" :data-src="contentCloudFront('/assets/v4/community/com-like1.png')" width="22" height="25" @click="likeVideo()">
      <span>{{ countLike }}</span>
    </div>
    <div class="community_watch_light">
      <img class="lazyload" :data-src="contentCloudFront('/assets/v4/community/com-watch.png')" width="27" height="25">
      <span>{{ video.view_numb }}</span>
    </div>
    <ul class="card_properties" @click="showVideo()">
      <li class="card_name">
        <a class="name_icon" :href="video.user_profile">
          <img class="lazyload" :data-src="video.user_avatar">
        </a>
        <a
          class="name_context video-title-nowrap"
          :href="video.user_profile"
        >{{ video.user_displayname }}</a>
      </li>
      <a
        class="card_type video-title-nowrap"
        href="#"
        :title="video.game_name"
      >{{ video.game_name_display }}</a>
    </ul>
    <div
      class="community_play_view"
      style="max-width: 100%;
    background-color: var(--video--bg-color); margin: unset"
    >
      <span @click="showVideo()">view this clip</span>
    </div>
    <div class="card_stats_new">
      <div class="card_statistics">
        <div class="card_likes_new">
          <img
            v-if="isLiked"
            class="video_liked lazyload"
            :data-src="contentCloudFrontWithVersion('/red_liked.png')"
            @click="likeVideo()"
          >
          <img
            v-else
            class="lazyload"
            :data-src="contentCloudFrontWithVersion('/red_liked.png')"
            @click="likeVideo()"
          >
          <span>{{ countLike }}</span>
        </div>
        <div class="card_views_new">
          <img class="lazyload" :data-src="contentCloudFrontWithVersion('/view.png')">
          <span id="view_numb">{{ video.view_numb }}</span>
        </div>
      </div>
      <div v-if="video.auth" class="stats_options">
        <a class="stats_options_btn" onclick="show_delete($(this))">
          <img class="lazyload" :data-src="contentCloudFrontWithVersion('/dots.png')">
        </a>
        <a class="stats_options_flag">
          <img
            class="tooltip_flag lazyload"
            :data-src="contentCloudFrontWithVersion('/flag.png')"
          >
        </a>
        <a
          class="stats_options_delete"
          href="javascript:void(0);"
          :data-vcode="video.code"
          :data-vid="video.id"
          :data-container="video.container"
        >Delete the video</a>
      </div>
    </div>
  </div>
</template>

<script>

import { component } from '../../../mixins/component';
import { EventBus, SHOW_VIDEO_CLIP_EMBED } from '../../../event-bus';

export default {
  mixins: [component],
  props: {
    video: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      running: false,
      countLike: 0,
      isLiked: false,
    };
  },
  created() {
    this.countLike = this.video.like_numb;
    this.isLiked = this.video.liked;
  },
  methods: {
    showVideo() {
      EventBus.$emit(SHOW_VIDEO_CLIP_EMBED, this.video.link);
    },
    likeVideo() {
      if (this.running) {
        return;
      }

      console.log('likeVideo');
      this.running = true;

      this.$http.post('/likevideo', {
        data: {
          vcode: this.video.code,
        },
      }).then((response) => {
        this.countLike = response.data.like;
        this.isLiked = response.data.like_state;
      }).finally(() => {
        console.log('update like video');
        this.running = false;
      });
    },
  },
};
</script>
